import { render } from "./BalanceOverviewChart.vue?vue&type=template&id=241e816d&ts=true"
import script from "./BalanceOverviewChart.vue?vue&type=script&lang=ts"
export * from "./BalanceOverviewChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__